"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _CustomTag = _interopRequireDefault(require("../CustomTag"));

var _reactIntl = require("react-intl");

require("./style.less");

var _antd = require("antd");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var NO_OP = function NO_OP() {};

var TagEditor = (0, _reactIntl.injectIntl)(function (_ref) {
  var intl = _ref.intl,
      _ref$tags = _ref.tags,
      tags = _ref$tags === void 0 ? [] : _ref$tags,
      loading = _ref.loading,
      _ref$onAdd = _ref.onAdd,
      onAdd = _ref$onAdd === void 0 ? NO_OP : _ref$onAdd,
      _ref$onDelete = _ref.onDelete,
      onDelete = _ref$onDelete === void 0 ? null : _ref$onDelete,
      canEdit = _ref.canEdit;
  var t = intl.messages;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      newTag = _useState2[0],
      setNewTag = _useState2[1];

  var inputRef = (0, _react.useRef)();
  var addNewTag = (0, _react.useCallback)(function () {
    if (newTag === '' || tags.includes(newTag)) {
      inputRef.current.focus();
      setNewTag('');
      return;
    }

    onAdd(newTag);
    setNewTag('');
  }, [tags, newTag, onAdd]);
  var handleChange = (0, _react.useCallback)(function (event) {
    setNewTag(event.target.value);
  }, []);
  var handleKeyPress = (0, _react.useCallback)(function (event) {
    if (event.key === 'Enter') {
      addNewTag();
    }
  }, [addNewTag]);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "CustomTagSelector-menu"
  }, tags.map(function (tag) {
    return /*#__PURE__*/_react.default.createElement(_CustomTag.default, {
      key: tag,
      name: tag,
      onDelete: canEdit && onDelete
    });
  }), canEdit ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    ref: inputRef,
    value: newTag,
    disabled: loading,
    suffix: loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
      size: "small"
    }) : '',
    onChange: handleChange,
    onKeyPress: handleKeyPress,
    className: "CustomTagSelector-input",
    placeholder: t.custom_tag_selector_placeholder
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: "CustomTagSelector-add",
    disabled: loading,
    onClick: addNewTag
  }, t.custom_tag_selector_add)) : null);
});

var CustomTagSelector = function CustomTagSelector(_ref2) {
  var intl = _ref2.intl,
      _ref2$tags = _ref2.tags,
      tags = _ref2$tags === void 0 ? [] : _ref2$tags,
      loading = _ref2.loading,
      onAdd = _ref2.onAdd,
      onDelete = _ref2.onDelete,
      className = _ref2.className,
      _ref2$dropdown = _ref2.dropdown,
      dropdown = _ref2$dropdown === void 0 ? false : _ref2$dropdown,
      canEdit = _ref2.canEdit;
  var t = intl.messages;

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      menuOpen = _useState4[0],
      setMenuOpen = _useState4[1];

  return /*#__PURE__*/_react.default.createElement("section", {
    className: "CustomTagSelector ".concat(className, " ").concat(dropdown ? 'CustomTagSelector-dropdown' : '')
  }, dropdown ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("section", {
    onClick: function onClick() {
      return setMenuOpen(!menuOpen);
    },
    className: "CustomTagSelector-button ".concat(menuOpen ? 'CustomTagSelector-open' : '')
  }, t.custom_tag_selector_title), !menuOpen ? null : /*#__PURE__*/_react.default.createElement(TagEditor, {
    tags: tags,
    loading: loading,
    onAdd: onAdd,
    onDelete: onDelete,
    canEdit: canEdit
  })) : /*#__PURE__*/_react.default.createElement(TagEditor, {
    tags: tags,
    loading: loading,
    onAdd: onAdd,
    onDelete: onDelete,
    canEdit: canEdit
  }));
};

var _default = (0, _reactIntl.injectIntl)(CustomTagSelector);

exports.default = _default;